// assets.js
const S3_BASE = "https://markoknow.s3.ap-south-1.amazonaws.com/static/org";

export const PEOPLE_ASSETS = {
  hero: `${S3_BASE}/pic.png`,
  multi: `${S3_BASE}/multi.png`,
  accordion: [
    { 
      id: 1, 
      normal: `${S3_BASE}/default-team.png`, 
      hover: `${S3_BASE}/slider-team.png`, 
      alt: "Team Impact" 
    },
    { 
      id: 2, 
      normal: `${S3_BASE}/default-longterm.png`, 
      hover: `${S3_BASE}/slider-longterm.png`, 
      alt: "Longterm Growth" 
    },
    { 
      id: 3, 
      normal: `${S3_BASE}/default-mentorhsip.png`, 
      hover: `${S3_BASE}/slider-mentorship.png`, 
      alt: "Mentorship Factor" 
    },
    { 
      id: 4, 
      normal: `${S3_BASE}/default-culture.png`, 
      hover: `${S3_BASE}/slider-culture.png`, 
      alt: "Culture Multiplier" 
    }
  ]
};